//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.OperationBuilder.js";
import "../CAM/CAM.InspectionFeatureDataFilterBuilder.js";
import "../CAM/CAM.InheritableDoubleBuilder.js";
import "../no/SelectPointList.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"ApproachDirection",1,"Direction",0],[0,"CurvatureFactor",1,0],[1,"DataFilterBuilder",0,"CAM.InspectionFeatureDataFilterBuilder",0],[0,"EndDistance",1,0],[0,"EndPercentage",1,0],[0,"IsPointDefinitionChanged",1,0],[0,"MaximumSpacing",1,0],[0,"MinimumNumberOfPoints",1,0],[0,"MinimumSpacing",1,0],[0,"Name",1,0],[1,"OffsetDistance",0,"CAM.InheritableDoubleBuilder",0],[0,"PointDataDefinition",1,0],[1,"PointSelector",0,"SelectPointList",0],[1,"SelectedCurves",0,"SelectNXObjectList",0],[1,"SelectedSurfaces",0,"SelectNXObjectList",0],[0,"StartDistance",1,0],[0,"StartEndMode",1,0],[0,"StartPercentage",1,0]],[[["selectedSurfaces"],"SetSelectedSurfaces",{},1,0],[[],"ReverseFeatureNormal",{},0,0],[[],"UpdateParams",{},0,0],[[],"ReverseOffsetDirection",{},0,0],[[],"UpdateOffset",{},0,0],[["showExisting"],"PreviewPointData",{},1,0],[[],"ErasePointDefinitionDisplay",{},0,0]],[]];
SPLM.CAM.InspectionCurveFeatureBuilder = class extends SPLM.CAM.OperationBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.InspectionCurveFeatureBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.InspectionCurveFeatureBuilder.PointDataDefinitionType = Object.freeze({
    "None" : "None", "PointSet" : "PointSet", "IndividualPoints" : "IndividualPoints"});

SPLM.CAM.InspectionCurveFeatureBuilder.StartEndModeType = Object.freeze({
    "Percentage" : "Percentage", "Distance" : "Distance"});

export default SPLM;